import { render, staticRenderFns } from "./GeneralMenu.vue?vue&type=template&id=a25bd9ee&scoped=true"
import script from "./GeneralMenu.vue?vue&type=script&lang=js"
export * from "./GeneralMenu.vue?vue&type=script&lang=js"
import style0 from "./GeneralMenu.vue?vue&type=style&index=0&id=a25bd9ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25bd9ee",
  null
  
)

export default component.exports